import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import vueTouch from 'kim-vue-touch'


// 移动端适配
// import 'amfe-flexible'
import '@/styles/font.css'
import '@/styles/appStyle.scss'
import '../public/css/updataStyle.scss'
import '@/rem/rem.js'
import VueLazyload from 'vue-lazyload'
import Router from 'vue-router'
// vant
import {
  NavBar,
  Form,
  Field,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Tab,
  Tabs,
  Cell,
  List,
  PullRefresh,
  ActionSheet,
  Popup,
  Row,
  Col,
  Badge,
  Search,
  Divider,
  CellGroup,
  Tag,
  Image,
  Dialog,
  DatetimePicker
} from 'vant'
Vue.use(NavBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Cell)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(ActionSheet)
Vue.use(Popup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Badge)
Vue.use(Search)
Vue.use(Divider)
Vue.use(CellGroup)
Vue.use(Tag)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(DatetimePicker)
Vue.use(vueTouch)
Vue.use(VueLazyload)
Vue.use(Router)







Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')